module.exports = __webpack_public_path__ + "static/CoffeeBean_pin_hover-9cfcdcb319cdda9ed0b2b0ac266fe135.png";